import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { request } from './utils/request'
import { getDomTitle } from './utils/setDomTitle'

Vue.config.productionTip = false
Vue.prototype.$request = request

router.beforeEach((to, from, next) => {
  document.title = getDomTitle() + '-' + to.meta.title || '默认名称'
  next()
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
